import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	ElementRef,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	Renderer2,
	TemplateRef,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-compact-footer",
	templateUrl: "./compact-footer.component.html",
	styleUrls: ["./compact-footer.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class CompactFooterComponent implements AfterViewInit {
	@ViewChild("footerContainer", { static: true }) footerRef!: ElementRef;

	@HostBinding("class.obg-compact-footer") hostCssClass = true;
	@HostBinding("class.wrapped") isWrapped = false;

	@Input()
	@coerceBoolean()
	showLicenseLogo = false;

	@Input()
	@coerceBoolean()
	showJurisdictionLicenseLogo = false;

	@ContentChild("customTemplate", { static: false })
	customTemplate: TemplateRef<unknown> | undefined;

	@Output()
	supportClick = new EventEmitter<void>();

	constructor(private renderer: Renderer2) {}

	ngAfterViewInit() {
		if (this.showJurisdictionLicenseLogo) {
			this.checkWrappingAfterImagesLoad();
		}
	}

	private checkWrappingAfterImagesLoad(): void {
		const footer = this.footerRef.nativeElement;
		const images: HTMLImageElement[] = Array.from(footer.querySelectorAll("img"));

		if (images.length === 0) {
			this.checkWrapping();
			return;
		}

		Promise.all(
			images.map((img) => (img.complete ? Promise.resolve() : new Promise((resolve) => (img.onload = resolve))))
		).then(() => this.checkWrapping());
	}

	private checkWrapping(): void {
		const footer = this.footerRef.nativeElement;
		const children = footer.children;

		if (children.length > 1 && children[0].offsetTop !== children[1].offsetTop) {
			this.renderer.addClass(footer, "wrapped");
		} else {
			this.renderer.removeClass(footer, "wrapped");
		}
	}
}
